import { isProdEnv } from "@fokused-me/core";

export interface IAndroidAppShell {
   showToast(message: string);
   getShellVersion(): string;
   getShellVersionCode(): number;
   getShellBuilt(): number;
   getAgentString(): string;
   saveFile(name: string, content: string): boolean;
   confirmAppLoaded();
   getInstallReferrer(): string;
}

export interface IAndroidIntent {
   action: string;
   content?: string;
   contentUri?: string;
   title?: string;
}

// TODO get rid of it
// Environment: Prod / Nonprod
// Shell: Web / Android / ...
export enum Environment {
   DEV,
   PROD,
   ANDROID,
}

export const isCompactMode = (width) => ["xs", "sm"].indexOf(width) > -1;

const ua = navigator.userAgent.toLowerCase();
export const isSafari = ua.indexOf("safari") > -1 && ua.indexOf("chrome") === -1;

export const androidAppShell = window && ((window as any).androidAppShell as IAndroidAppShell | undefined);

export const appEnvironment = androidAppShell ? Environment.ANDROID : isProdEnv() ? Environment.PROD : Environment.DEV;

export const isAndroidEnv = !!androidAppShell;

export const appShellName = appEnvironment === Environment.ANDROID ? "android" : "web";

const STAT_VALUES = [1, 5, 10, 20, 50, 100, 200, 500, 1000, 5000, 10000];
export const getStatValue = (value: number) => {
   let prev = STAT_VALUES[0];
   for (const v of STAT_VALUES) {
      if (value < v) {
         break;
      } else {
         prev = v;
      }
   }

   return prev;
};

// export const getEnvironment = () => (window as any).wvContainer ? Environment.WEBVIEW : Environment.PROD;
export const appSystemInfo = {
   name: process.env.REACT_APP_NAME || "",
   version: process.env.REACT_APP_VERSION || "",
   repoCommitId: process.env.REACT_REPO_COMMIT_ID || "",
   repoBranch: process.env.REACT_REPO_BRANCH || "",
   buildDate: process.env.REACT_APP_BUILD_DATE || new Date().toISOString(),
   installReferrer: androidAppShell && androidAppShell.getInstallReferrer ? androidAppShell.getInstallReferrer() : "",
};

export const extractGaCampaignParamsFromAndroidShell = () => {
   if (appSystemInfo.installReferrer) {
      // process installReferrer from Android Shell
      try {
         const GaCompaignFiels = {
            utm_source: "campaignSource",
            utm_medium: "campaignMedium",
            utm_term: "campaignKeyword",
            utm_content: "campaignContent",
            utm_campaign: "campaignName",
            // anid: '',
         };

         const paramsArr = appSystemInfo.installReferrer
            .replace(/%2B/g, " ")
            .split("&")
            .map((param) => param.split("="))
            .filter((pair) => pair.length === 2);

         const campaignParams = paramsArr.reduce((prev, curr) => {
            const field = GaCompaignFiels[curr[0]];
            if (field) {
               prev[field] = curr[1];
            }
            return prev;
         }, {});

         return campaignParams;
      } catch (e) {
         //
      }
   }

   return null;
};

// export const appStats = {
//    appActiveDays: 1,
//    appActiveNotes: 1,
//    appSyncOn: "no",
//    appShellName,
//    appVersion: appSystemInfo.version,
//    appShellVersion: androidAppShell ? androidAppShell.getShellVersion() : "",
// };
